module.exports = __webpack_public_path__ + "img/illustrator-login.f9f4810b.svg";